import React from 'react';

// Tailwind는 동적으로 조합한 클래스명을 인식하지 못하므로 전체 클래스명으로 매핑
const XL_BG_CLASS = {
  white: 'xl:bg-white',
  transparent: 'xl:bg-transparent',
};

interface PageContainerProps {
  children: React.ReactNode;
  bgColor?: keyof typeof XL_BG_CLASS;
}

/** 본문 폭 제한 페이지 래퍼. xl 미만은 좌우 여백 없이 꽉 채우고, xl 이상은 최대 1176px 가운데 정렬(좌우 최소 20px) (타이틀은 PageContainerTitle 사용) */
export const PageContainer = ({
  children,
  bgColor = 'white',
}: PageContainerProps) => {
  return (
    <div className={`relative m-auto xl:max-w-page ${XL_BG_CLASS[bgColor]}`}>
      {children}
    </div>
  );
};
